import { useForm, useWatch } from 'react-hook-form';
import { useDebounceValue } from 'usehooks-ts';

import { useProtocolValidityOptions } from './useProtocolValidityOptions';

import type { ProtocolFiltersForm } from '../Protocols.types';

/** Same debounce as the plan units search, so both lists react alike */
const SEARCH_DEBOUNCE_IN_MS = 300;

/**
 * The filter bar's form, and the values the list filters on. The validity select cannot be cleared:
 * "all" is an explicit option, as "no employer" is on the plan units filter.
 */
export const useProtocolFilters = () => {
  'use memo';
  const validityOptions = useProtocolValidityOptions();
  const { control } = useForm<ProtocolFiltersForm>({
    defaultValues: { search: '', validity: validityOptions[0] }
  });
  const search = useWatch({ control, name: 'search' });
  const validity = useWatch({ control, name: 'validity' });
  const [debouncedSearch] = useDebounceValue(search, SEARCH_DEBOUNCE_IN_MS);

  return {
    control,
    validityOptions,
    search: debouncedSearch ?? '',
    filter: validity?.value ?? 'all'
  };
};
